module.exports = __webpack_public_path__ + "img/Tx_Cup_2022_4.fe865305.png";